module.exports = __webpack_public_path__ + "static/media/tire_track_logo.4c9033be.svg";